import { attach, createEvent, createStore, sample } from "effector";

import { closeSession } from "@entities/session";

type Router = {
  invalidate: () => Promise<void>;
};

export const setRouter = createEvent<Router>();

export const $router = createStore<Router | null>(null).on(
  setRouter,
  (_, router) => router,
);

export const invalidateRouterFx = attach({
  effect: (router) => {
    if (!router) {
      return;
    }
    return router.invalidate();
  },
  source: $router,
});

sample({
  clock: closeSession,
  target: invalidateRouterFx,
});
